import TextEditor from "../../common/TextEditor"

const Security = () => {
  return (
    <div className="main-content">
      <div className="container-fluid">
        <div className='d-flex justify-content-between'>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link active`}
              >
                Security
              </button>
            </li>


          </ul>
        </div>
        <TextEditor type={"security"} />
      </div>


    </div>
  )
}

export default Security